import { cleanRequestParams } from './cleanRequestParams';
import { isGuid } from './isGuid';

export const dataHelpers = {
    isGuid,
    cleanRequestParams,
};
